<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2" v-if="loading">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <template v-if="!loading">
              <div class="d-flex bd-highlight mb-3">
                <div class="me-auto p-2 bd-highlight">
                  <h4 class="card-title">
                    {{ detail.address_street.toUpperCase() }},
                    {{ detail.state.name.toUpperCase() }},
                    {{ detail.city.toUpperCase() }}, {{ detail.zip_code }}
                  </h4>
                  <!-- Card Title -->
                </div>
                <div class="p-2 bd-highlight">
                  <router-link
                    :to="'/mpg/addresses/' + detail.address_id + '/edit'"
                    class="btn btn-primary waves-effect waves-light"
                  >
                    Edit
                  </router-link>
                </div>

                <div class="p-2 bd-highlight">
                  <b-button
                    class="btn btn-danger waves-effect waves-light"
                    v-b-modal.delete_org_modal
                  >
                    Delete</b-button
                  >
                </div>
              </div>
              <!-- Start Modal -->
              <b-modal
                id="delete_org_modal"
                tabindex="-1"
                aria-labelledby="delete_modal_label"
                aria-hidden="true"
                hide-footer
              >
                <template #modal-header>
                  <h6 class="text-center">
                    DELETE {{ detail.address_street.toUpperCase() }},
                    {{ detail.state.name.toUpperCase() }},
                    {{ detail.city.toUpperCase() }}, {{ detail.zip_code }}
                  </h6>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    :disabled="loadingAction"
                    @click="$bvModal.hide('delete_org_modal')"
                  ></button>
                </template>

                <div class="modal-body">
                  <h3 class="text-center">Are you sure?</h3>
                  <h6 class="text-center">You won't be able to revert this.</h6>
                  <div class="d-grid gap-2 d-md-block text-center">
                    <form method="POST">
                      <input
                        type="hidden"
                        name="csrfmiddlewaretoken"
                        value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                      />
                      <button
                        class="btn btn-danger waves-effect waves-light"
                        type="submit"
                        name="delete_opportunity"
                        value="11"
                        @click="deleteAddress(detail.address_id)"
                        :disabled="loadingAction"
                      >
                        Delete
                      </button>
                      <button
                        class="btn btn-light waves-effect waves-light"
                        type="button"
                        :disabled="loadingAction"
                        data-bs-dismiss="modal"
                        @click="$bvModal.hide('delete_org_modal')"
                      >
                        Cancel
                      </button>
                    </form>
                  </div>
                </div>
              </b-modal>
              <!-- End Modal -->
              <div class="row">
                <div class="col-lg-12">
                  <b-tabs
                    v-model="tabIndex"
                    class="nav-tabs-custom nav-justified"
                    active-tab-class="p-3"
                    @activate-tab="onChangeTab"
                  >
                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="fas fa-details"></i
                        ></span>
                        <span class="d-none d-sm-block">Address Details</span>
                      </template>
                      <b-card-title></b-card-title>
                      <b-card-text>
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="card h-100">
                              <div class="card-body">
                                <h4 class="card-title">Details</h4>
                                <!-- Card Title -->
                                <p></p>

                                <!-- Start Table -->
                                <div class="table-responsive mb-0">
                                  <table
                                    class="
                                      table
                                      align-middle
                                      table-striped table-nowrap
                                      mb-0
                                    "
                                  >
                                    <tbody>
                                      <tr>
                                        <td>Address Street</td>
                                        <td>{{ detail.address_street }}</td>
                                      </tr>

                                      <tr>
                                        <td>City</td>
                                        <td>{{ detail.city }}</td>
                                      </tr>

                                      <tr>
                                        <td>State</td>
                                        <td>{{ detail.state.name }}</td>
                                      </tr>

                                      <tr>
                                        <td>ZIP Code</td>
                                        <td>{{ detail.zip_code }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <!-- End Table -->
                              </div>
                              <!-- End Card Body -->
                            </div>
                            <!-- End Card -->
                          </div>
                          <!-- End Col -->

                          <div class="col-lg-6">
                            <div class="card h-100">
                              <div class="card-body">
                                <h4 class="card-title">Metadata</h4>
                                <!-- Card Title -->
                                <p></p>

                                <!-- Start Table -->
                                <div class="table-responsive mb-0">
                                  <table
                                    class="
                                      table
                                      align-middle
                                      table-striped table-nowrap
                                      mb-0
                                    "
                                  >
                                    <tbody>
                                      <tr>
                                        <td>Version</td>
                                        <td>{{ detail.version }}</td>
                                      </tr>

                                      <tr>
                                        <td>Created by</td>
                                        <td>
                                          {{ detail.created_by.username }}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Created at</td>
                                        <td>
                                          {{
                                            moment(detail.created_at).format(
                                              "MMMM DD, YYYY, HH:mm A"
                                            )
                                          }}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Modified by</td>
                                        <td>
                                          {{ detail.modified_by.username }}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Modified at</td>
                                        <td>
                                          {{
                                            moment(detail.modified_at).format(
                                              "MMMM DD, YYYY, HH:mm A"
                                            )
                                          }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <!-- End Table -->
                              </div>
                              <!-- End Card Body -->
                            </div>
                            <!-- End Card -->
                          </div>
                          <!-- End Col -->
                        </div>
                      </b-card-text>
                    </b-tab>
                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="far fa-organizations"></i
                        ></span>
                        <span class="badge rounded-pill bg-danger float-end">{{
                          detail.organizations_addresses.filter(e => e.property_status !== 'active').length
                        }}</span>
                        <span class="badge rounded-pill bg-success float-end me-2">{{
                          detail.organizations_addresses.filter(e => e.property_status === 'active').length
                        }}</span>
                        <span class="d-none d-sm-block">Organizations</span>
                      </template>
                      <b-card-text>
                        <div class="d-flex justify-content-end">
                          <router-link
                            :to="
                              '/mpg/addresses/' +
                              detail.address_id +
                              '/organization/add'
                            "
                            class="btn btn-primary waves-effect waves-light"
                          >
                            Add Organization
                          </router-link>
                        </div>

                        <p></p>

                        <div class="card">
                          <div class="card-body">
                            <!-- Start Filter -->
                            <div class="row">
                              <div
                                class="
                                  d-flex
                                  flex-row-reverse
                                  justify-content-between
                                "
                              >
                                <div>
                                  <b-dropdown
                                    id="dropdown-1"
                                    variant="link"
                                    toggle-class="text-reset pt-0"
                                  >
                                    <template #button-content>
                                      <span class="text-muted"
                                        >Property Status:</span
                                      >
                                      <span class="fw-semibold text-capitalize"
                                        >{{ filterStatus
                                        }}<i
                                          class="mdi mdi-chevron-down ms-1"
                                        ></i
                                      ></span>
                                    </template>
                                    <b-dropdown-item
                                      @click="filterStatus = 'active'"
                                      >Active</b-dropdown-item
                                    >
                                    <b-dropdown-item
                                      @click="filterStatus = 'expired'"
                                      >Expired</b-dropdown-item
                                    >
                                  </b-dropdown>
                                  <!-- End Filter -->
                                </div>
                                <h4 class="card-title mb-4">
                                  Organizations List
                                </h4>
                              </div>
                            </div>

                            <div class="row g-1">
                              <div class="table-responsive mb-0">
                                <table
                                  class="
                                    table
                                    table-hover
                                    table-borderless
                                    align-middle
                                    table-centered table-nowrap
                                    mt-1
                                    mb-0
                                    ctrl-h
                                  "
                                  style="overflow: visible"
                                >
                                  <thead class="table-light">
                                    <tr>
                                      <th></th>
                                      <th>Legal Entity Name</th>
                                      <th>Experian ID</th>
                                      <th>Zoom Info ID</th>
                                      <th>Address Type</th>
                                      <th>Status</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr
                                      v-for="(
                                        org, index
                                      ) in filterStatusOrg"
                                      :key="index"
                                    >
                                      <td class="text-center">
                                        <router-link
                                          :to="
                                            '/mpg/addresses/' +
                                            org.address +
                                            '/organization/' +
                                            org.organization.organization_id +
                                            '/edit'
                                          "
                                          class="
                                            btn btn-link
                                            text-primary
                                            mb-0
                                            p-0
                                          "
                                        >
                                          <i class="fas fa-edit text-xs"></i>
                                        </router-link>
                                      </td>
                                      <td>
                                        <router-link
                                          :to="
                                            '/mpg/organizations/' +
                                            org.organization.organization_id +
                                            '/details'
                                          "
                                          >{{
                                            org.organization.name
                                          }}</router-link
                                        >
                                      </td>
                                      <td>
                                        {{ org.organization.bin_number }}
                                      </td>
                                      <td>
                                        {{ org.organization.zoominfo_id }}
                                      </td>
                                      <td>
                                        <template
                                          v-for="(type, ix) in org.address_type"
                                        >
                                          <span style="margin-right: 5px"
                                            :class="
                                              'text-capitalize badge ' +
                                              (type === 'headquarters'
                                                ? 'bg-headq'
                                                : type === 'service_location'
                                                ? 'bg-serv-loc'
                                                : 'bg-bil-addr')
                                            "
                                            :key="ix"
                                            >{{
                                              type === "headquarters"
                                                ? "Headquarters"
                                                : type === "service_location"
                                                ? "Service Location"
                                                : type === "billing_address"
                                                ? "Billing Address"
                                                : type
                                            }}</span
                                          >
                                        </template>
                                      </td>
                                      <td>
                                        <span
                                          :class="
                                            'badge bg-soft text-capitalize ' +
                                            (org.property_status === 'active'
                                              ? 'bg-success  text-white'
                                              : 'bg-danger text-white')
                                          "
                                          >{{ org.property_status }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <!-- <div
                                class="col-sm-7 mb-3"
                                v-for="(
                                  org, index
                                ) in detail.organizations_addresses"
                                :key="index"
                              >

                                <div class="card mb-lg-0 h-100">
                                  <div class="card-body">
                                    <div class="float-end">
                                      <router-link
                                        :to="
                                          '/mpg/addresses/' +
                                          org.address +
                                          '/organization/' +
                                          org.organization.organization_id +
                                          '/edit'
                                        "
                                        class="
                                          btn btn-light
                                          waves-effect
                                          btn-sm
                                        "
                                      >
                                        <i
                                          class="
                                            mdi mdi-square-edit-outline
                                            me-1
                                          "
                                        ></i
                                        >Edit
                                      </router-link>
                                    </div>
                                    <h5 class="my-0 text-primary text-truncate">
                                      <router-link
                                        :to="
                                          '/mpg/organizations/' +
                                          org.organization.organization_id +
                                          '/details'
                                        "
                                        >{{
                                          org.organization.name
                                        }}</router-link
                                      >
                                    </h5>
                                    <p class="card-text">
                                      <br />

                                      <template
                                        v-for="(type, ix) in org.address_type"
                                      >
                                        <span
                                          class="badge bg-warning"
                                          :key="ix"
                                          >{{ type }}</span
                                        >
                                        &nbsp;&nbsp;
                                      </template>
                                    </p>
                                    <div class="float-end">
                                      <h5>
                                        <span
                                          :class="
                                            'badge bg-soft text-capitalize ' +
                                            (org.property_status === 'active'
                                              ? 'bg-success  text-white'
                                              : 'bg-danger text-white')
                                          "
                                          >{{ org.property_status }}</span
                                        >
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div> -->
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-tab>
                    <!-- <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="far fa-activities"></i
                        ></span>
                        <span class="d-none d-sm-block">Activities</span>
                      </template>
                      <b-card-text> Empty </b-card-text>
                    </b-tab> -->
                  </b-tabs>
                  <!-- End Card -->
                </div>
                <!-- End Col -->
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.table.ctrl-h > :not(caption) > * > * {
  padding: 1.058rem 1rem;
}
</style>

<script>
import { addressesService } from '../services/addresses.service'

import moment from 'moment'

export default {
  name: 'AddressesDetail',
  components: {},
  data () {
    return {
      detail: null,
      loading: true,
      loadingAction: false,
      tabIndex: 0,
      filterStatus: 'active'
    }
  },
  watch: {
    // filterStatus () {
    //   this.detail.organizations_addresses.sort((x, y) => {
    //     return x.property_status === this.filterStatus
    //       ? -1
    //       : y.property_status === this.filterStatus
    //         ? 1
    //         : 0
    //   })
    // }
  },
  computed: {
    filterStatusOrg () {
      return this.detail.organizations_addresses.filter((x) => {
        return x.property_status === this.filterStatus
      })
    }
  },
  created () {
    if (this.$route.params.type === 'details') {
      this.tabIndex = 0
    } else {
      this.tabIndex = 1
    }
    if (!this.$route.params.id || this.$route.params.id === '') {
      this.$router.push('/mpg/addresses')
    }

    addressesService.getDataById(this.$route.params.id).then((rs) => {
      this.detail = rs
      this.loading = false
    })
  },
  methods: {
    moment,
    deleteAddress (id) {
      this.loadingAction = true
      addressesService.deleteDataById(id).then((rs) => {
        this.loadingAction = false
        this.$router.push('/mpg/addresses')
      })
    },
    onSubmit () {},
    onChangeTab (tab) {
      switch (tab) {
        case 0:
          this.$router.push(`/mpg/addresses/${this.$route.params.id}/details`)
          break
        case 1:
          this.$router.push(
            `/mpg/addresses/${this.$route.params.id}/organizations`
          )
          break
        default:
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/AddressesDetail.vue